const sessionCache = new Map();

/**
 * Cache GET responses in-memory (per SPA session).
 * @param {string} key
 * @param {() => Promise<any>} fetcher
 * @param {number} ttlMs
 * @returns {Promise<any>}
 */
export async function cachedSessionGet(key, fetcher, ttlMs = 10 * 60 * 1000) {
  const now = Date.now();
  const existing = sessionCache.get(key);

  if (existing && existing.expiresAt > now) {
    return existing.value;
  }

  const value = await fetcher();
  sessionCache.set(key, { value, expiresAt: now + ttlMs });
  return value;
}

export function clearSessionCache() {
  sessionCache.clear();
}
